import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=57f8266e&scoped=true"
import script from "./menu.vue?vue&type=script&lang=ts"
export * from "./menu.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./menu.vue?vue&type=style&index=0&id=57f8266e&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "57f8266e",
  "2cb3763d"
  
)

export default component.exports